enum SitesFilterFieldNames {
  Sectors = 'sectors',
}

export default SitesFilterFieldNames;
